angular.module('mean.contacts').controller('CompanyContactController', ['$scope', 'Global', 'Contacts', 'MeanUser', 'userService', 'ngDialog', 'Messages', 'toaster', '$location', 'Requests', 'Users', 'builderService', '$filter', '$rootScope',
  function($scope, Global, Contacts, MeanUser, userService, ngDialog, Messages, toaster, $location, Requests, Users, builderService, $filter, $rootScope) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = MeanUser.user;

    $scope.contacts = $scope.$parent.contacts;

    $scope.company_contacts = [];

    var inReqList = function(id) {
        for(var i=0; i<$scope.my_current_requests.length; i=i+1) {
            if($scope.my_current_requests[i].requestee._id === id)
              return true;
        }

        return false;
    }

    Requests.query({'requestor': $scope.user._id}, function(my_current_requests) {
        $scope.my_current_requests = my_current_requests;
        userService.getUsers($scope.user.trade[0], userService.getCompanyCode($scope.user.username)).then(function(users) {
            users.forEach(function(user) {
                //skip me
                if(user._id === $scope.user._id) return;

                var in_list = $filter('filter')($scope.contacts.personal, {'_id': user._id}, true);

                //only add who we don't already have a contact with
                if(in_list.length === 0) {
                    //now lets see if we already have a request
                    if(!inReqList(user._id)) {
                        user.role = user.roles[0];
                        user.trade = user.trade[0];
                        $scope.company_contacts.push(user);
                    }
                }
            });
        });
    });

    $scope.sendRequest = function(item) {
        var body = $scope.user.name + ' has sent a contact request.  To accept <a href="' +
            $location.absUrl() + '">Click Here</a>';
        console.log(body);


        var request = new Requests({
            requestor: $scope.user._id,
            requestee: item._id,
            date: new Date
        });

        request.$save(function(result) {
            var message = new Messages({
                sender: $scope.user._id,
                receiver: item._id,
                date: new Date(),
                status: 'unread',
                folder: 'inbox',
                subject: 'New Contact Request',
                body: body
            });

            var index = $scope.company_contacts.indexOf(item);
            $scope.company_contacts.splice(index, 1);

            message.$save();
            $rootScope.$broadcast('update-request-list');
            toaster.pop('success', 'Contact Request', 'Request has been sent.');
        }, function(error) {
            toaster.pop('error', 'Contact Request', 'There is a problem with your request.');
        });
    };

    $scope.addUserContact = function() {
        console.log(this.new_contact_username.length);
        if(builderService.isBuilder($scope.user.username) &&
                builderService.isBuilder(this.new_contact_username)) {
            toaster.pop('error', 'Contact Request', 'Cannot add username ' + this.new_contact_username);
            return;
        }

        if(!builderService.isBuilder($scope.user.username) &&
                !builderService.isBuilder(this.new_contact_username)) {
            toaster.pop('error', 'Contact Request', 'Cannot add username ' + this.new_contact_username);
            return;
        }

        Users.query({'username': this.new_contact_username}, function(users) {
            if(users.length === 1) {
                var body = $scope.user.name + ' has sent a contact request.  To accept <a href="' +
                    $location.absUrl() + '">Click Here</a>';
                //place a check here to make sure the selected user
                //is part of one of the associated business contacts
                var request = new Requests({
                    requestor: $scope.user._id,
                    requestee: users[0]._id,
                    date: new Date
                });

                request.$save(function(result) {
                    var message = new Messages({
                        sender: $scope.user._id,
                        receiver: users[0]._id,
                        date: new Date(),
                        status: 'unread',
                        folder: 'inbox',
                        subject: 'New Contact Request',
                        body: body
                    });

                    message.$save();
                    toaster.pop('success', 'Contact Request', 'Request has been sent.');
                }, function(error) {
                    toaster.pop('error', 'Contact Request', 'There is a problem with your request.');
                });
            } else if(users.length === 0){
                toaster.pop('error', 'Contact Request', 'Could not find username ' + this.new_contact_username);
            }
        });
    };

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/controllers/companyContactController.js